import React from 'react';
import DocumentPage from '../../components/DocumentPage';

const Bills = () => {
  const columns = [
    { key: 'total', label: 'Total', type: 'currency' },
    { key: 'due_date', label: 'Due Date', type: 'date' },
  ];

  const formFields = [
    { name: 'supplier_id', label: 'Supplier', type: 'party', required: true },
    { name: 'purchase_order_id', label: 'Purchase Order ID', type: 'text', placeholder: 'Purchase order ID, if this bill is for a PO' },
    { name: 'subtotal', label: 'Subtotal', type: 'number', defaultValue: 0 },
    { name: 'tax', label: 'Tax', type: 'number', defaultValue: 0 },
    { name: 'total', label: 'Total', type: 'number', defaultValue: 0 },
    { name: 'due_date', label: 'Due Date', type: 'date' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'pending',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'paid', label: 'Paid' },
        { value: 'overdue', label: 'Overdue' },
      ],
    },
  ];

  return (
    <DocumentPage
      title="Bills"
      description="Manage supplier bills with print and email"
      apiEndpoint="bills"
      partyType="supplier"
      partyApi="suppliers"
      columns={columns}
      formFields={formFields}
      docType="bill"
    />
  );
};

export default Bills;
